import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import { Container, Row, Col } from 'reactstrap'
import CarsList from '../CarsList'
import ReturnsList from '../ReturnsList'
import '../CarsList.css'
import { TagsQuery } from "../../Functions/querys"
import AvailableCarsHeader from "./AvailableCarsHeader"
import ListingTabs from "../../Material/ListingTabs"
import { buildPresets } from "../../Filters/presetFilters"
import { FILTER_PARAM } from "../../Filters/filterUrl"

import withApolloClient from '../../withApolloClient'

// Available Cars' one default filter, expressed as an Advanced Filters preset
// -- the same FilterInput shape the query already sends for user filters, so
// the popover, the chips and the query all read one source of truth.
// Editable: users could toggle Is Ready on the legacy bar, so they still can.
const AVAILABLE_CARS_PRESET = buildPresets([
    { fieldName: "is_ready", filterType: "equal", filterValues: true, editable: true },
])
// Scheduled Returns gets no preset: its legacy `returnType` default
// ("Confirmed Returns") is a page-mode string that picks a returnStage
// value below, not a car_return filter -- CarReturn.return_type only
// accepts Return/Switch/Lost, so it stays exactly as it was.
const SCHEDULED_RETURNS_PRESET = buildPresets([])

const tabs = [
    { id: "#avaialble", name: "Available Cars", filterValues: { orderBy: ["-id"] }, presets: AVAILABLE_CARS_PRESET },
    { id: "#scheduled", name: "Scheduled Returns", filterValues: { returnType: "Confirmed Returns", orderBy: ["-id"] }, presets: SCHEDULED_RETURNS_PRESET },
]

class AvailableCarsContainer extends Component {

    constructor(props) {
        super(props)
        this.state = {
            activeTab: "Available Cars",
            selectedIds: [],
            filterValues: {
                orderBy: ["-id"]
            },
            // presets and defaultPresets start out equal -- setPresets only ever
            // updates presets, so defaultPresets stays the active tab's declared
            // set and is what Reset returns to.
            presets: AVAILABLE_CARS_PRESET,
            defaultPresets: AVAILABLE_CARS_PRESET,
        }
    }

    updateOrder = (string) => {
        let order = this.state.filterValues && this.state.filterValues.orderBy ? [...this.state.filterValues.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ filterValues: { ...this.state.filterValues, orderBy: order } })
    };

    updateSelection = (selection) => {
        if (Array.isArray(selection)) {
            this.setState({ selectedIds: selection })
        } else {
            if (this.state.selectedIds.includes(selection))
                this.setState({ selectedIds: this.state.selectedIds.filter(item => item != selection) })
            else
                this.setState({ selectedIds: [...this.state.selectedIds, selection] })
        }
    }
    setPresets = (presets) => this.setState({ presets })

    // Writes the tab hash through navigate() (path + search + hash together) instead of
    // `window.location.hash = …`. Two problems with the direct write: react-router's own
    // location.hash (read by useLocation() everywhere, including Filters/filterUrl.js) went
    // stale, so applying a filter right after a tab switch could silently revert the URL to
    // the previous tab's hash; and it never touched `?filter=`. Available Cars (entity `car`)
    // and Scheduled Returns (entity `car_return`) both read that one shared query param
    // through useAdvancedFilters() -- CarsList and ReturnsList respectively -- so without
    // clearing it here, filters applied on one tab leak into the other tab's GraphQL
    // `filters` variable (car-only fields like is_ready/tag_name even error out against
    // CarReturnFilterSet). Same fix as Material/TabbedListingPage.js's writeTabHash.
    navigateToTab = (tabIndex, { replace = false } = {}) => {
        const params = new URLSearchParams(this.props.location.search)
        params.delete(FILTER_PARAM)
        this.props.navigate(
            { pathname: this.props.location.pathname, search: params.toString(), hash: tabs[tabIndex].id },
            { replace }
        )
    }

    componentDidMount() {
        if (window.location.hash && tabs.map(item => item.id).includes(window.location.hash)) {
            let tabIndex = tabs.findIndex(tab => tab.id === window.location.hash)
            this.setState({
                filterValues: { ...tabs[tabIndex].filterValues },
                activeTab: tabs[tabIndex].name,
                presets: tabs[tabIndex].presets,
                defaultPresets: tabs[tabIndex].presets,
            })
            this.navigateToTab(tabIndex, { replace: true })
        } else {
            this.setState({
                filterValues: { ...tabs[0].filterValues },
                activeTab: tabs[0].name,
                presets: tabs[0].presets,
                defaultPresets: tabs[0].presets,
            })
            this.navigateToTab(0, { replace: true })
        }
    }
    changeTab = (value) => {
        let tabIndex = tabs.findIndex(tab => tab.name === value)
        this.setState({
            activeTab: value,
            filterValues: { ...tabs[tabIndex].filterValues },
            presets: tabs[tabIndex].presets,
            defaultPresets: tabs[tabIndex].presets,
        })
        this.navigateToTab(tabIndex)
    }

    render() {
        return (

            < Container fluid className="AvailableCarsContainer CarListContainer" >
                <ListingTabs
                    tabs={[
                        { ...tabs[0], iconClassName: "fa fa-car" },
                        { ...tabs[1], iconClassName: "fa fa-calendar-o" },
                    ]}
                    activeTab={this.state.activeTab}
                    activeValueKey="name"
                    onChange={this.changeTab}
                />
                <AvailableCarsHeader
                    activeTab={this.state.activeTab}
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    selectedIds={this.state.selectedIds}
                    location={this.props.location} history={this.props.navigate}
                    resetSelectedIds={() => this.setState({ selectedIds: [] })}
                    presets={this.state.presets}
                    setPresets={this.setPresets}
                    defaultPresets={this.state.defaultPresets}
                />
                <Row>
                    <Col sm="12">
                        {this.state.activeTab && this.state.activeTab === "Available Cars" &&
                            <CarsList
                                currentUser={this.props.currentUser}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm !== null ? this.state.filterValues.searchTerm : null}
                                orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                                updateOrder={this.updateOrder}
                                presets={this.state.presets}
                            />
                        }
                        {this.state.activeTab && this.state.activeTab === "Scheduled Returns" &&
                            <ReturnsList
                                currentUser={this.props.currentUser}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm !== null ? this.state.filterValues.searchTerm : null}
                                activeTab="Available Cars"
                                selectedDrivers={this.state.selectedIds}
                                updateDriversSelection={this.updateSelection}
                                orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                                agreementStage={10}
                                returnStage={this.state.filterValues && this.state.filterValues.returnType === "Confirmed Returns" ? [2] : [1]}
                                updateOrder={this.updateOrder}
                                presets={this.state.presets}
                            />
                        }
                    </Col>
                </Row>
            </Container >
        )
    }
}


//-----------------------------------
export default graphql(TagsQuery, {
    props: ({ data: { loading, carTags } }) => ({
        carTags
    })
})(withApolloClient(AvailableCarsContainer))
